import { Injectable } from '@angular/core';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http';
import { environment } from "../../environments/environment"

@Injectable({
  providedIn: 'root'
})
export class PdfserviceService {

  constructor(private http:HttpClient) { }

  public async exportToPdf(elementId: string, fileName: string) {


    const doc = new jspdf.jsPDF();
    const element = document.getElementById(elementId);

    if (!element) {
        console.error('Element not found!');
        return;
    }

    const canvas = await html2canvas(element);
    const imgData = canvas.toDataURL('image/jpeg', 0.7);
    const imgWidth = 210; // mm (A4 width)
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    // Check if content overflows the first page
    const contentHeight = imgHeight;
    const pageHeight = doc.internal.pageSize.height;

    if (contentHeight > pageHeight) {
        // Calculate how many pages are needed
        const totalPages = Math.ceil(contentHeight / pageHeight);

        // Loop through each page and add the content
        for (let i = 0; i < totalPages; i++) {
            if (i > 0) {
                // Add a new page for subsequent pages
                doc.addPage();
            }
            
            // Calculate the y position for the current page
            const yPos = -pageHeight * i;

            // Add the image with adjusted y position
            doc.addImage(imgData, 'PNG', 0, yPos, imgWidth, imgHeight);
        }
    } else {
        // If content fits on one page, just add the image
        doc.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
    }

    const pdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);
    this.saveblob(pdfBlob, fileName);
    const printWindow = window.open(pdfUrl, '_blank');





    
//     const doc = new jspdf.jsPDF();
//     const element = document.getElementById(elementId);

//     if (!element) {
//       console.error('Element not found!');
//       return;
//     }

//     const canvas = await html2canvas(element);
//     const imgData = canvas.toDataURL('image/jpeg',0.7);
//     const imgWidth = 210; // mm (A4 width)
//     const imgHeight = (canvas.height * imgWidth) / canvas.width;

//     doc.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
//     // doc.save(fileName + '.pdf');

//     const pdfBlob = doc.output('blob');
//     const pdfUrl = URL.createObjectURL(pdfBlob);
// this.saveblob(pdfBlob,fileName)
//     const printWindow = window.open(pdfUrl, '_blank');
  
//     // Optionally, you can trigger the print dialog
//     // if (printWindow) {
//     //   printWindow.onload = () => {
//     //     printWindow.print();
//     //   };
//     // } else {
//     //   console.error('Failed to open print window.');
//     // }
   }

   public async uploadPdf(elementId: string, fileName: string) {
    const doc = new jspdf.jsPDF();
    const element = document.getElementById(elementId);

    if (!element) {
      console.error('Element not found!');
      return;
    }
    

    const canvas = await html2canvas(element);
    const imgData = canvas.toDataURL('image/jpeg',0.7);
    const imgWidth = 210; // mm (A4 width)
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    // doc.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
 // Check if content overflows the first page
 const contentHeight = imgHeight;
 const pageHeight = doc.internal.pageSize.height;

 if (contentHeight > pageHeight) {
     // Calculate how many pages are needed
     const totalPages = Math.ceil(contentHeight / pageHeight);

     // Loop through each page and add the content
     for (let i = 0; i < totalPages; i++) {
         if (i > 0) {
             // Add a new page for subsequent pages
             doc.addPage();
         }
         
         // Calculate the y position for the current page
         const yPos = -pageHeight * i;

         // Add the image with adjusted y position
         doc.addImage(imgData, 'PNG', 0, yPos, imgWidth, imgHeight);
     }
 } else {
     // If content fits on one page, just add the image
     doc.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
 }





    const pdfBlob = doc.output('blob');

    this.saveblob(pdfBlob,fileName)
     
   }




   public async DownloadPdf(elementId: string, fileName: string) {
    const doc = new jspdf.jsPDF();
    const element = document.getElementById(elementId);

    if (!element) {
      console.error('Element not found!');
      return;
    }
    

    const canvas = await html2canvas(element);
    const imgData = canvas.toDataURL('image/jpeg',0.7);
    const imgWidth = 210; // mm (A4 width)
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    // doc.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
 // Check if content overflows the first page
 const contentHeight = imgHeight;
 const pageHeight = doc.internal.pageSize.height;

 if (contentHeight > pageHeight) {
     // Calculate how many pages are needed
     const totalPages = Math.ceil(contentHeight / pageHeight);

     // Loop through each page and add the content
     for (let i = 0; i < totalPages; i++) {
         if (i > 0) {
             // Add a new page for subsequent pages
             doc.addPage();
         }
         
         // Calculate the y position for the current page
         const yPos = -pageHeight * i;

         // Add the image with adjusted y position
         doc.addImage(imgData, 'PNG', 0, yPos, imgWidth, imgHeight);
     }
 } else {
     // If content fits on one page, just add the image
     doc.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
 }




    const pdfBlob = doc.output('blob');

    this.saveblob(pdfBlob,fileName)
     doc.save(fileName + '.pdf');
   }
  
   savePdf(request:any,filtename:any){
    const formData: FormData = new FormData();
    formData.append('file', request,filtename);
    return this.http.post(environment.API_URL+"/api/orders/invoice/save",formData,{observe:"response"});

  }

  saveblob(data:any,fileName:any){
    this.savePdf(data,fileName+'.pdf')
    .subscribe( {
      next : (res:any) => {
        if(res) {
         
      console.log(res)
        
        } else {    
        } 
      },error : (err) => {
        
  
  
      }
    }
  )
  }
}
